import axios from "axios";

//const baseUrl = 'http://crm.gard';
const baseUrl = 'https://crm.gardennumberone.com';

export default class GroupService {
    static async getAll() {
        try {
            const response = await axios.post(baseUrl+'/api/groups');
            return response.data.data;

        } catch (err) {
            console.log(err);
        }
    }
    static async getOne(id) {
        try {
            const response = await axios.get(baseUrl+'/api/group/'+id);
            return response.data;
        } catch (err) {
            console.log(err);
        }
    }
    static async create(porductData) {
        try {
            const response = await axios.post(baseUrl+'/api/group/create', porductData);
            return response;
        } catch (err) {
            return(err.response);
        }
    }
    static async edit(porductData) {
        try {
            const response = await axios.post(baseUrl+'/api/group/edit', porductData);
            return response.data;
        } catch (err) {
            return(err.response);
        }
    }
}
